module.exports = __webpack_public_path__ + "static/LocationSendai-5bdc6b1f18ecff725f1f5b8465377d2a.png";